import { Reducer } from 'redux';
import { KpiACTypes, KpiACState } from './types';

const INITIAL_STATE: KpiACState = {
  data: [],
  error: false,
  loading: false,
};

const reducer: Reducer<KpiACState> = (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case KpiACTypes.LOAD_REQUEST:
      return {
        ...state,
        loading: true,
      };
    case KpiACTypes.LOAD_SUCCESS:
      return {
        ...state,
        loading: false,
        error: false,
        data: action.payload.data,
      };
    case KpiACTypes.LOAD_FAILURE:
      return { ...state, loading: false, error: true, data: INITIAL_STATE.data };
    default:
      return state;
  }
};

export default reducer;
